import BaseScreenImage from "../../../components/general/BaseScreenImage"
import { API } from "../../../api/api"
import { TImageSection } from "../../../types/index"

const heightClassMap: Record<TImageSection["height"], string> = {
    "standart-80vh": "max-h-[80dvh]",
    vh100: "max-h-[100dvh]",
    vh60: "max-h-[60dvh]",
    vh40: "max-h-[40dvh]",
    vh20: "max-h-[20dvh]",
}

type ImageSectionProps = Pick<TImageSection, "image" | "view" | "height">

export default function ImageSection({ image, view, height }: ImageSectionProps) {
    const imageUrl = image?.data?.attributes?.url

    if (!imageUrl) return null

    const heightClass = heightClassMap[height]
    const isAnimationView = view === "w-section_animation" || view === "w-section_animation_darkBg"
    const isSectionWidthView =
        view === "w-section_animation" ||
        view === "w-section_no-animation" ||
        view === "w-section_animation_darkBg" ||
        view === "w-section_no-animation_darkBg"

    if (isAnimationView) {
        return (
            <BaseScreenImage
                url={imageUrl}
                alt="Solution image"
                imageClassName={`!aspect-auto ${heightClass}`}
            />
        )
    }

    return (
        <div className={` ${isSectionWidthView ? "max-w-page mx-auto px-4 md:px-8 xl:px-0" : ""}`}>
            <img
                src={API.img + imageUrl}
                alt="Solution image"
                className={`w-full object-cover ${heightClass} ${isSectionWidthView ? "" : ""}`}
            />
        </div>
    )
}